
import { computed, defineComponent, PropType } from 'vue'

// @components
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    name: 'new-list',
    components: {
        Loader,
        TheButton,
    },
    props: {
        title: {
            type: String,
            default: 'Title prop',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: 'Загрузка...',
        },
        failed: {
            type: Boolean,
            default: false,
        },
        failedText: {
            type: String,
            default: 'Произошла ошибка',
        },
        failedButtonText: {
            type: String,
            default: 'Обновить',
        },
        emptyText: {
            type: String,
            default: 'Список пуст',
        },
        options: {
            type: Array as PropType<Record<string, any>[]>,
            default: () => [],
        },
    },
    emits: ['reload'],
    setup(props, { emit }) {
        const onReload = () => {
            emit('reload')
        }

        const isRenderingState = computed(
            () => props.loading || props.failed || props.options.length === 0
        )

        return {
            onReload,
            //
            isRenderingState,
        }
    },
})
